<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.orderStatus === 'D' || row.orderStatus === 'T'
              ? 'danger'
              : row.orderStatus === 'R'
              ? 'warning'
              : row.orderStatus === 'Y' ||
                row.orderStatus === 'P' ||
                row.orderStatus === 'C'
              ? 'success'
              : 'light'
          "
        >
          {{ row.v_orderStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { code: row.orderCode },
                  query: { orderNo: row.orderNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
            v-show="row.orderStatus === 'N' || row.orderStatus === 'R'"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { code: row.orderCode },
                  query: { orderNo: row.orderNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="allow('D')"
            v-show="row.orderStatus === 'N' || row.orderStatus === 'R'"
          >
            <i class="el-icon-delete tool-btn" @click="del(row.orderCode)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_submit_review') || '提交审核'"
            placement="top"
            v-if="allow('T')"
            v-show="row.orderStatus === 'N' || row.orderStatus === 'R'"
          >
            <i
              class="el-icon-position tool-btn"
              @click="submit(row.orderCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_export') || '导出合同'"
            placement="top"
            v-if="allow('E')"
            v-show="row.orderStatus === 'Y'"
          >
            <i
              class="el-icon-download tool-btn"
              @click="exportContract(row.orderCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_print') || '打印清单'"
            placement="top"
            v-if="allow('P')"
            v-show="row.orderStatus !== 'D'"
          >
            <i
              class="el-icon-printer tool-btn"
              @click="exportCheckList(row.orderCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_copy') || '复制订单'"
            placement="top"
            v-if="allow('C')"
            v-show="row.orderStatus !== 'D'"
          >
            <i
              class="el-icon-document-copy tool-btn"
              @click="copyOrder(row.orderCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:submitInfo="{ row }">
        <span> {{ row.submitByName }} </span>
        <br />
        <span> {{ row.submitTime }} </span>
      </template>
      <template v-slot:reviewInfo="{ row }">
        <span> {{ row.reviewByName }} </span>
        <br />
        <span> {{ row.reviewTime }} </span>
      </template>
      <template v-slot:createInfo="{ row }">
        <span> {{ row.createByName }} </span>
        <br />
        <span> {{ row.createTime }} </span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span> {{ row.modifyByName }} </span>
        <br />
        <span> {{ row.modifyTime }} </span>
      </template>
      <template v-slot:orderAmountInfo="{ row }">
        <span> {{ row.v_orderAmount }} {{ row.v_currencyUnit }}</span>
      </template>
      <template v-slot:orderSalesAmountInfo="{ row }">
        <span> {{ row.v_orderSalesAmount }} {{ row.v_salesCurrencyUnit }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      width="700px"
      :title="$l('btn_export') || '导出合同'"
      :close-on-click-modal="false"
      :before-close="() => close()"
    >
      <div class="print_btn_group">
        <el-button plain @click="exportExcel('single')">
          {{ $l('btn_print_use_single_po_template') || '使用单PO模版' }}
        </el-button>
        <el-button plain @click="exportExcel('single-image')">
          {{
            $l('btn_print_use_single_po_template_image') || '使用单PO模版(带图)'
          }}
        </el-button>
        <el-button plain @click="exportExcel('multiple')">
          {{ $l('btn_print_use_multiple_po_template') || '使用多PO模版' }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="checkVisible"
      show-close
      :visible.sync="checkVisible"
      width="500px"
      :title="$l('dialog_title_print_order_checklist') || '订单核对清单打印'"
      :close-on-click-modal="false"
      :before-close="() => close()"
      destroy-on-close
      append-to-body
    >
      <div class="print_btn_group">
        <el-button plain @click="onClickPrint('single')">
          {{ $l('btn_print_use_single_po_template') || '使用单PO模版' }}
        </el-button>
        <el-button plain @click="onClickPrint('multiple')">
          {{ $l('btn_print_use_multiple_po_template') || '使用多PO模版' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      visible: false,
      checkVisible: false,
      orderCode: '',
    }
  },
  methods: {
    del(orderCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.loadingOpen()
          this.$api.orderInfoDelApi({ orderCode: orderCode }).then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    submit(orderCode) {
      this.$confirm(
        this.$l('INDEX.tips_question_submitAudit') || '是否要提交审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.loadingOpen()
          this.$api
            .orderInfoSubmitApi({ orderCode })
            .then(() => {
              this.loadingClose()
              this.$message({
                showClose: true,
                message:
                  this.$l('INDEX.tips_Submitted_successfully') || '提交成功！',
                type: 'success',
              })
              this.$emit('reload')
            })
            .catch(() => {
              this.loadingClose()
            })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'order-customerOrderDetail',
        params: { ...params, pageType },
        query,
      })
    },
    exportContract(code) {
      this.orderCode = code
      this.visible = true
      // 导出合同
    },
    exportCheckList(code) {
      this.orderCode = code
      this.checkVisible = true
      // 导出清单
    },
    close() {
      this.orderCode = ''
      this.visible = false
      this.checkVisible = false
    },
    exportExcel(model) {
      // 调用清单导出接口，确认是否有对应数据
      let parms = {
        orderCode: this.orderCode,
        exportType: model,
      }
      this.loadingOpen()
      this.$api
        .orderExportCheckDataApi(parms)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            // 通过数据检查，增加下载任务
            const taskName = `factory-order-contract-${model}`
            this.addExportTask(taskName)
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    onClickPrint(model) {
      // 调用清单导出接口，确认是否有对应数据
      let parms = {
        orderCode: this.orderCode,
        exportType: model,
      }
      this.loadingOpen()
      this.$api
        .orderExportCheckDataApi(parms)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            // 通过数据检查，增加下载任务
            const taskName = `factory-order-checklist-${model}`
            this.addExportTask(taskName)
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    addExportTask(taskName) {
      const context = { orderCode: this.orderCode }
      this.loadingOpen()
      this.$api
        .SYS_EXPORT_TASK(taskName, context)
        .then((res) => {
          this.loadingClose()
          const { status } = res || {}
          if (200 === status) {
            this.$message({
              message:
                this.$l('added_to_the_download_center') ||
                '导出任务已经添加到下载中心，请稍后从下载中心下载文件',
              type: 'success',
            })
            this.close()
            return
          }
          this.$message.error(
            this.$l('Description_Failed_to_add_export_task') ||
              '导出任务添加失败'
          )
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(
            this.$l('Description_Failed_to_add_export_task') ||
              '导出任务添加失败'
          )
        })
      this.close()
    },
    copyOrder(orderCode) {
      // 复制订单
      this.$confirm(
        this.$l('tips_question_copy') || '是否需要复制该订单？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.loadingOpen()
          this.$api
            .orderInfoCopyApi({ oldOrderCode: orderCode })
            .then((res) => {
              this.loadingClose()
              const { status } = res
              if (status !== 200) {
                this.$message.error(
                  this.$l('tips_copy_error') || '订单复制失败！'
                )
                return
              }
              this.$message({
                showClose: true,
                message: this.$l('tips_copy_ok') || '订单复制成功！',
                type: 'success',
              })
              this.$emit('reload')
              this.openEditPage({
                pageType: 'edit',
                params: { code: res.body.orderCode },
                query: { orderNo: res.body.orderNo },
              })
            })
            .catch(() => {
              this.loadingClose()
              this.$message.error(
                this.$l('tips_copy_error') || '订单复制失败！'
              )
            })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
  },
}
</script>
<style scoped>
.print_btn_group {
  height: 110px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
